<template>
    <span
        class="inline-flex rounded-full px-2 text-xs leading-5 font-semibold whitespace-nowrap"
        :class="computedClasses"
    >
        {{ label }}
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { pillClasses, type Tone } from './statusTone';

type BadgeVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'default';

interface BadgeProps {
    label: string;
    variant?: BadgeVariant;
    customClasses?: string;
}

const props = withDefaults(defineProps<BadgeProps>(), {
    variant: 'default',
    customClasses: '',
});

const variantTone: Record<BadgeVariant, Tone> = {
    primary: 'brand',
    secondary: 'neutral',
    success: 'success',
    danger: 'error',
    warning: 'warning',
    info: 'info',
    // gray-50 was near-invisible on white cards
    light: 'neutral',
    dark: 'inverse',
    default: 'neutral',
};

const computedClasses = computed(() => {
    return props.customClasses || pillClasses[variantTone[props.variant]];
});
</script>
